import React from 'react'
import Header from '../../organisms/Header/Header'

import Constants from '../../../app/utils/constants'
import colors from '../../theme/color'
import CommonHeroSection from '../../organisms/commonherosection/CommonHeroSection'

const HeroSection = () => {
  const { hero } = Constants.servicePage

  return (
    <CommonHeroSection>
    <section className="relative isolate min-h-[50vh] overflow-hidden lg:min-h-[72vh] xl:min-h-[76vh] 2xl:min-h-[80vh] min-[2560px]:min-h-[86vh]" >

      <div className="relative">
        <Header />
      </div>

       <div className="relative mx-auto flex min-h-[460px] w-full max-w-[1480px] flex-col items-center justify-center px-5 text-center md:min-h-[50vh] md:px-8 md:pb-5 md:pt-16 lg:min-h-[58vh] lg:px-10 xl:min-h-[60vh] xl:px-12 2xl:max-w-[1600px] 2xl:px-16 2xl:pb-28 min-[2560px]:max-w-[1800px] min-[2560px]:px-20 min-[2560px]:pb-0">
        <h1 className="font-rajdhani text-[2rem] font-semibold leading-[1.05] text-white sm:text-[2.95rem] md:text-[3.4rem] lg:text-[3.6rem] xl:text-[4rem] 2xl:text-[4.8rem] min-[2560px]:text-[6rem]">
          {hero.titleLines[0]}
          <span className="block">{hero.titleLines[1]}</span>
        </h1>

        <p
          className="mt-4 max-w-[980px] font-gilroy-medium text-[1rem] leading-[1.45] sm:text-[1.08rem] md:text-[1.2rem] lg:text-[1.22rem] xl:text-[1.4rem] 2xl:max-w-[1200px] 2xl:text-[1.9rem] min-[2560px]:max-w-[1800px] min-[2560px]:text-[2.4rem]"
          style={{ color: colors.serviceHeroBody }}
        >
          {hero.description}
        </p>
      </div>
    </section>
    </CommonHeroSection>
  )
}

export default HeroSection
